export default __webpack_public_path__ + "2d1dc60efbfc47fe1f838026b3004bd9.png";